import React from 'react';
import './Modal.css';

export default function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Decorative Dots */}
        <span className="dot dot-top-left" />
        <span className="dot dot-top-right" />
        <span className="dot dot-bottom-left" />
        <span className="dot dot-bottom-right" />

        {/* Close button */}
        {/* <button className="modal-close" onClick={onClose}>✕</button> */}

        {children}
      </div>
    </div>
  );
}
